export const cardsList = {
    show: {
        alias: true,
    },
};
